// Text localization system for domain-based content
import { getCurrentLanguage } from './languageSwitcher';

// Centralized text dictionary
export const TEXT_DICTIONARY = {
  // Navigation
  'nav.home': {
    'cs-CZ': 'Domů',
    'sk-SK': 'Domov',
    'pl-PL': 'Strona główna',
    'hu-HU': 'Főoldal'
  },
  'nav.bikes': {
    'cs-CZ': 'Kola',
    'sk-SK': 'Bicykle',
    'pl-PL': 'Rowery',
    'hu-HU': 'Kerékpárok'
  },
  'nav.about': {
    'cs-CZ': 'O Nukeproof',
    'sk-SK': 'O Nukeproof',
    'pl-PL': 'O Nukeproof',
    'hu-HU': 'A Nukeproof-ről'
  },
  'nav.dealers': {
    'cs-CZ': 'Prodejci',
    'sk-SK': 'Predajcovia',
    'pl-PL': 'Dealerzy',
    'hu-HU': 'Kereskedők'
  },
  'nav.configurator': {
    'cs-CZ': 'Konfigurátor',
    'sk-SK': 'Konfigurátor',
    'pl-PL': 'Konfigurator',
    'hu-HU': 'Konfigurátor'
  },
  'nav.contact': {
    'cs-CZ': 'Kontakt',
    'sk-SK': 'Kontakt',
    'pl-PL': 'Kontakt',
    'hu-HU': 'Kapcsolat'
  },
  'nav.pruvodce_gravel': {
    'cs-CZ': 'Průvodce kol Gravel',
    'sk-SK': 'Sprievodca kolami Gravel',
    'pl-PL': 'Przewodnik po rowerach Gravel',
    'hu-HU': 'Gravel kerékpárok útmutatója'
  },
  'nav.close': {
    'cs-CZ': 'Zavřít',
    'sk-SK': 'Zavrieť',
    'pl-PL': 'Zamknij',
    'hu-HU': 'Bezár'
  },

  // Footer sections
  'footer.links': {
    'cs-CZ': 'ODKAZY',
    'sk-SK': 'ODKAZY',
    'pl-PL': 'LINKI',
    'hu-HU': 'LINKEK'
  },
  'footer.bikes': {
    'cs-CZ': 'KOLA',
    'sk-SK': 'BICYKLE',
    'pl-PL': 'ROWERY',
    'hu-HU': 'KERÉKPÁROK'
  },
  'footer.social': {
    'cs-CZ': 'SOCIÁLNÍ SÍTĚ',
    'sk-SK': 'SOCIÁLNE SIETE',
    'pl-PL': 'MEDIA&nbsp;SPOŁECZNOŚCIOWE',
    'hu-HU': 'KÖZÖSSÉGI MÉDIA'
  },
  'footer.language': {
    'cs-CZ': 'JAZYK',
    'sk-SK': 'JAZYK',
    'pl-PL': 'JĘZYK',
    'hu-HU': 'NYELV'
  },
  'footer.official_site': {
    'cs-CZ': 'Oficiální stránky',
    'sk-SK': 'Oficiálna stránka',
    'pl-PL': 'Oficjalna strona',
    'hu-HU': 'Hivatalos oldal'
  },

  'footer.prodlouzena_zaruka': {
    'cs-CZ': 'Prodloužená záruka',
    'sk-SK': 'Predĺžená záruka',
    'pl-PL': 'Rozszerzona gwarancja',
    'hu-HU': 'Kiterjesztett garancia'
  },

  // Bike categories
  'bikes.gravel': {
    'cs-CZ': 'Gravel',
    'sk-SK': 'Gravel',
    'pl-PL': 'Gravel',
    'hu-HU': 'Gravel'
  },
  'bikes.mtb': {
    'cs-CZ': 'MTB',
    'sk-SK': 'MTB',
    'pl-PL': 'MTB',
    'hu-HU': 'MTB'
  },
  'bikes.road': {
    'cs-CZ': 'Road',
    'sk-SK': 'Road',
    'pl-PL': 'Road',
    'hu-HU': 'Országúti'
  },
  'bikes.cyclocross': {
    'cs-CZ': 'Cyklokros',
    'sk-SK': 'Cyklokros',
    'pl-PL': 'Przełaj',
    'hu-HU': 'Cyclocross'
  },
  'bikes.ebike': {
    'cs-CZ': 'E-Bike',
    'sk-SK': 'E-Bike',
    'pl-PL': 'E-Bike',
    'hu-HU': 'E-Bike'
  },

  // Home page
  'home.page_title': {
    'cs-CZ': 'Nukeproof | Domů',
    'sk-SK': 'Nukeproof | Domov',
    'pl-PL': 'Nukeproof | Strona główna',
    'hu-HU': 'Nukeproof | Főoldal'
  },
  'home.dealers_title': {
    'cs-CZ': 'Prodejci Nukeproof',
    'sk-SK': 'Predajcovia Nukeproof',
    'pl-PL': 'Dealerzy Nukeproof',
    'hu-HU': 'Nukeproof kereskedők'
  },
  'home.dealers_subtitle': {
    'cs-CZ': 'Najděte svého prodejce kol Nukeproof',
    'sk-SK': 'Nájdite svojho predajcu bicyklov Nukeproof',
    'pl-PL': 'Znajdź swojego dealera rowerów Nukeproof',
    'hu-HU': 'Találja meg Nukeproof kerékpár kereskedőjét'
  },
  'home.dealers_button': {
    'cs-CZ': 'Zobrazit',
    'sk-SK': 'Zobraziť',
    'pl-PL': 'Pokaż',
    'hu-HU': 'Megjelenítés'
  },
  'home.news_title': {
    'cs-CZ': 'Novinky',
    'sk-SK': 'Novinky',
    'pl-PL': 'Aktualności',
    'hu-HU': 'Hírek'
  },
  'home.more_articles': {
    'cs-CZ': 'Více článků',
    'sk-SK': 'Viac článkov',
    'pl-PL': 'Więcej artykułów',
    'hu-HU': 'További cikkek'
  },

  // Contact page specific terms
  'contact.page_title': {
    'cs-CZ': 'Nukeproof | Kontakt',
    'sk-SK': 'Nukeproof | Kontakt',
    'pl-PL': 'Nukeproof | Kontakt',
    'hu-HU': 'Nukeproof | Kapcsolat'
  },
  'contact.quick_contact_title': {
    'cs-CZ': 'Rychlý kontakt',
    'sk-SK': 'Rýchly kontakt',
    'pl-PL': 'Szybki kontakt',
    'hu-HU': 'Gyors kapcsolat'
  },
  'contact.billing_title': {
    'cs-CZ': 'Fakturační údaje',
    'sk-SK': 'Fakturačné údaje',
    'pl-PL': 'Dane do faktury',
    'hu-HU': 'Számlázási adatok'
  },
  'contact.quick_contact': {
    'cs-CZ': 'Nebo nám napište',
    'sk-SK': 'Alebo nám napíšte',
    'pl-PL': 'Lub napisz do nas',
    'hu-HU': 'Vagy írjon nekünk'
  },
  'contact.call_us': {
    'cs-CZ': 'Zavolejte nám',
    'sk-SK': 'Zavolajte nám',
    'pl-PL': 'Zadzwoń do nas',
    'hu-HU': 'Hívjon minket'
  },
  'contact.tel': {
    'cs-CZ': 'TEL.:',
    'sk-SK': 'TEL.:',
    'pl-PL': 'TEL.:',
    'hu-HU': 'TEL.:'
  },
  'contact.billing_info': {
    'cs-CZ': 'IČO:',
    'sk-SK': 'IČO:',
    'pl-PL': 'NIP:',
    'hu-HU': 'Adószám:'
  },
  'contact.vat_id': {
    'cs-CZ': 'DIČ:',
    'sk-SK': 'DIČ:',
    'pl-PL': 'NIP UE:',
    'hu-HU': 'EU adószám:'
  },
  'contact.registry': {
    'cs-CZ': 'OR:',
    'sk-SK': 'OR:',
    'pl-PL': 'KRS:',
    'hu-HU': 'Cégnyilvántartás:'
  },
  'contact.file_number': {
    'cs-CZ': 'Spisová značka',
    'sk-SK': 'Spisová značka',
    'pl-PL': 'Numer w rejestrze',
    'hu-HU': 'Iktatószám'
  },

  // Dealers page
  'dealers.search_placeholder': {
    'cs-CZ': 'Najít prodejce',
    'sk-SK': 'Nájsť predajcu',
    'pl-PL': 'Znajdź dealera',
    'hu-HU': 'Kereskedő keresése'
  },
  'dealers.searching': {
    'cs-CZ': 'Hledání nejbližší pobočky',
    'sk-SK': 'Hľadanie najbližšej pobočky',
    'pl-PL': 'Szukanie najbliższego dealera',
    'hu-HU': 'Legközelebbi kereskedő keresése'
  },
  'dealers.not_found': {
    'cs-CZ': 'Tato adresa nebyla nalezena',
    'sk-SK': 'Táto adresa nebola nájdená',
    'pl-PL': 'Ten adres nie został znaleziony',
    'hu-HU': 'Ez a cím nem található'
  },
  'dealers.dealer': {
    'cs-CZ': 'Web prodejce',
    'sk-SK': 'Web predajca',
    'pl-PL': 'Dealer',
    'hu-HU': 'Kereskedő'
  },
  'dealers.loadingtitle': {
    'cs-CZ': 'Načítání',
    'sk-SK': 'Načítava sa',
    'pl-PL': 'Ładowanie',
    'hu-HU': 'Betöltés'
  },
  'dealers.loadingtext': {
    'cs-CZ': 'Může to chvíli trvat, děkujeme za pochopení',
    'sk-SK': 'Môže to chvíľu trvať, ďakujeme za pochopenie',
    'pl-PL': 'To może chwilę potrwać, dziękujemy za cierpliwość',
    'hu-HU': 'Ez eltarthat egy ideig, köszönjük a megértést'
  },

  // General terms
  'general.o-nukeproof_page_title': {
    'cs-CZ': 'Nukeproof | O nás',
    'sk-SK': 'Nukeproof | O nás',
    'pl-PL': 'Nukeproof | O nas',
    'hu-HU': 'Nukeproof | Rólunk'
  },
  'general.novinky_page_title': {
    'cs-CZ': 'Nukeproof | Novinky',
    'sk-SK': 'Nukeproof | Novinky',
    'pl-PL': 'Nukeproof | Nowości',
    'hu-HU': 'Nukeproof | Hírek'
  },
  'general.loading': {
    'cs-CZ': 'Načítání...',
    'sk-SK': 'Načítava sa...',
    'pl-PL': 'Ładowanie...',
    'hu-HU': 'Betöltés...'
  },
  'general.show': {
    'cs-CZ': 'Zobrazit',
    'sk-SK': 'Zobraziť',
    'pl-PL': 'Pokaż',
    'hu-HU': 'Megjelenítés'
  },
  'general.show_button': {
    'cs-CZ': 'Zobrazit',
    'sk-SK': 'Zobraziť',
    'pl-PL': 'Pokaż',
    'hu-HU': 'Megjelenítés'
  },
  'general.copyright': {
    'cs-CZ': 'Copyright ©',
    'sk-SK': 'Copyright ©',
    'pl-PL': 'Copyright ©',
    'hu-HU': 'Copyright ©'
  },
  'general.articles': {
    'cs-CZ': 'ČLÁNKY',
    'sk-SK': 'ČLÁNKY',
    'pl-PL': 'ARTYKUŁY',
    'hu-HU': 'CIKKEK'
  },
  'general.home_caps': {
    'cs-CZ': 'DOMŮ',
    'sk-SK': 'DOMOV',
    'pl-PL': 'STRONA GŁÓWNA',
    'hu-HU': 'FŐOLDAL'
  },
  'general.go_to_bike': {
    'cs-CZ': 'Přejít na kolo',
    'sk-SK': 'Prejsť na bicykel',
    'pl-PL': 'Przejdź do roweru',
    'hu-HU': 'Ugrás a kerékpárhoz'
  },
  'general.all_bikes': {
    'cs-CZ': 'Všechna kola',
    'sk-SK': 'Všetky bicykle',
    'pl-PL': 'Wszystkie rowery',
    'hu-HU': 'Összes kerékpár'
  },
  'general.bikes_caps': {
    'cs-CZ': 'KOLA',
    'sk-SK': 'BICYKLE',
    'pl-PL': 'ROWERY',
    'hu-HU': 'KERÉKPÁROK'
  },
  'general.pruvodce_button': {
    'cs-CZ': 'Průvodce kol',
    'sk-SK': 'Sprievodca bicyklami',
    'pl-PL': 'Przewodnik rowerowy',
    'hu-HU': 'Kerékpáros útmutató'
  },
  'general.pruvodce_text': {
    'cs-CZ': 'Nevíte si rady které kolo zvolit? Podívejte se na našeho průvodce.',
    'sk-SK': 'Neviete si rady, ktoré kolo zvoliť? Pozrite sa na nášho sprievodcu.',
    'pl-PL': 'Nie wiesz, które rower wybrać? Zobacz naszego przewodnika.',
    'hu-HU': 'Nem tudod, melyik kerékpárt válaszd? Nézd meg útmutatónkat.'
  },
  'general.pruvodce_text_small': {
    'cs-CZ': 'Nevíte si rady které kolo zvolit?',
    'sk-SK': 'Neviete si rady ktoré kolo zvoliť?',
    'pl-PL': 'Nie wiesz, które rower wybrać?',
    'hu-HU': 'Nem tudod, melyik kerékpárt válaszd?'
  },
  'general.pruvodce_button_small': {
    'cs-CZ': 'Zobrazit průvodce kol',
    'sk-SK': 'Zobraziť sprievodcu bicyklami',
    'pl-PL': 'Pokaż przewodnika rowerowego',
    'hu-HU': 'Mutasd a kerékpár útmutatót'
  },
  'general.lookforprodejce': {
    'cs-CZ': 'Vyhledat prodejce',
    'sk-SK': 'Vyhľadat predajcu',
    'pl-PL': 'Wyszukiwanie dealerów',
    'hu-HU': 'Kereskedők keresése'
  },
  'general.whatismysize': {
    'cs-CZ': 'Jaká je moje velikost?',
    'sk-SK': 'Aká je moja veľkosť?',
    'pl-PL': 'Jaka jest moja wielkość?',
    'hu-HU': 'Melyik a mé méretem?'
  },

  // Configurator page
  'configurator.page_title': {
    'cs-CZ': 'Nukeproof | Konfigurátor',
    'sk-SK': 'Nukeproof | Konfigurátor',
    'pl-PL': 'Nukeproof | Konfigurator',
    'hu-HU': 'Nukeproof | Konfigurátor'
  },
  'configurator.configure': {
    'cs-CZ': 'Konfigurovat',
    'sk-SK': 'Konfigurovať',
    'pl-PL': 'Konfiguruj',
    'hu-HU': 'Konfigurálás'
  },
  'configurator.open': {
    'cs-CZ': 'Otevřít',
    'sk-SK': 'Otvoriť',
    'pl-PL': 'Otwórz',
    'hu-HU': 'Megnyitás'
  },
  'configurator.customer_configs': {
    'cs-CZ': 'Konfigurace našich zákazníků',
    'sk-SK': 'Konfigurácie našich zákazníkov',
    'pl-PL': 'Konfiguracje naszych klientów',
    'hu-HU': 'Ügyfeleink konfigurációi'
  },
  'dealers.title': {
  'cs-CZ': 'Prodejci',
  'sk-SK': 'Predajcovia', 
  'pl-PL': 'Dealerzy',
  'hu-HU': 'Kereskedők'
},  'dealers.search_subtitle': {
  'cs-CZ': 'Vyhledej si prodejce Nukeproof',
  'sk-SK': 'Vyhľadaj si predajcu Nukeproof',
  'pl-PL': 'Znajdź dealera Nukeproof',
  'hu-HU': 'Keress Nukeproof kereskedőt'
},

  // Bike detail page
  'bike.available_colors': {
    'cs-CZ': 'Dostupné barvy',
    'sk-SK': 'Dostupné farby',
    'pl-PL': 'Dostępne kolory',
    'hu-HU': 'Elérhető színek'
  },
  'bike.available_sizes': {
    'cs-CZ': 'Dostupné velikosti',
    'sk-SK': 'Dostupné veľkosti',
    'pl-PL': 'Dostępne rozmiary',
    'hu-HU': 'Elérhető méretek'
  },
  'bike.about_product': {
    'cs-CZ': 'O produktu',
    'sk-SK': 'O produkte',
    'pl-PL': 'O produkcie',
    'hu-HU': 'A termékről'
  },
  'bike.features': {
    'cs-CZ': 'Vlastnosti',
    'sk-SK': 'Vlastnosti',
    'pl-PL': 'Właściwości',
    'hu-HU': 'Tulajdonságok'
  },
  'bike.learn_more': {
    'cs-CZ': 'Zjistit víc',
    'sk-SK': 'Zistiť viac',
    'pl-PL': 'Dowiedz się więcej',
    'hu-HU': 'További információ'
  },
  'bike.close': {
    'cs-CZ': 'Zavřít',
    'sk-SK': 'Zavrieť',
    'pl-PL': 'Zamknij',
    'hu-HU': 'Bezár'
  },
  'bike.specifications': {
    'cs-CZ': 'Specifikace',
    'sk-SK': 'Špecifikácie',
    'pl-PL': 'Specyfikacje',
    'hu-HU': 'Specifikációk'
  },
  'bike.configure_custom': {
    'cs-CZ': 'Nakonfigurovat vlastní kolo',
    'sk-SK': 'Nakonfigurovať vlastný bicykel',
    'pl-PL': 'Skonfiguruj własny rower',
    'hu-HU': 'Saját kerékpár konfigurálása'
  },
  'bike.geometry': {
    'cs-CZ': 'Geometrie',
    'sk-SK': 'Geometria',
    'pl-PL': 'Geometria',
    'hu-HU': 'Geometria'
  },
  'bike.technical_info_download': {
    'cs-CZ': 'Technické informace k rámu ke stažení zde.',
    'sk-SK': 'Technické informácie o ráme na stiahnutie tu.',
    'pl-PL': 'Informacje techniczne o ramie do pobrania tutaj.',
    'hu-HU': 'Műszaki információk a vázról letölthetők itt.'
  },
  'bike.size_table': {
    'cs-CZ': 'Tabulka velikostí',
    'sk-SK': 'Tabuľka veľkostí',
    'pl-PL': 'Tabela rozmiarów',
    'hu-HU': 'Mérettáblázat'
  },
  'bike.spec_table_bottom_text': {
    'cs-CZ': '*Vyhrazujeme si právo na změnu informací o produktech. To se týká vybavení, specifikací, modelů, barev i cen, a to kdykoli a bez předchozího upozornění.',
    'sk-SK': '*Vyhradzujeme si právo na zmenu informácií o produktoch. To sa týka vybavenia, špecifikácií, modelov, farieb i cien, a to kedykoľvek a bez predchádzajúceho upozornenia.',
    'pl-PL': '*Zastrzegamy sobie prawo do zmiany informacji o produktach. Dotyczy to wyposażenia, specyfikacji, modeli, kolorów i cen, w dowolnym momencie i bez wcześniejszego powiadomienia.',
    'hu-HU': '*Fenntartjuk a jogot a termékekkel kapcsolatos információk megváltoztatására. Ez vonatkozik a felszerelésre, a specifikációkra, a modellekre, a színekre és az árakra, bármikor és előzetes értesítés nélkül.'
  },
  'bike.dropdown_offer': {
    'cs-CZ': 'Varianta',
    'sk-SK': 'Varianta',
    'pl-PL': 'Wariant',
    'hu-HU': 'Változat'
  },
  'bike.price': {
    'cs-CZ': 'Cena',
    'sk-SK': 'Cena',
    'pl-PL': 'Cena',
    'hu-HU': 'Ár'
  },
  'bike.price-start': {
    'cs-CZ': 'od',
    'sk-SK': 'od',
    'pl-PL': 'od',
    'hu-HU': 'tól'
  },
  'bike.get_more': {
    'cs-CZ': 'Přečíst více',
    'sk-SK': 'Zistiť viac',
    'pl-PL': 'Dowiedz się więcej',
    'hu-HU': 'További információ'
  },
  'pruvodce.page_title': {
    'cs-CZ': 'Nukeproof | Průvodce kol',
    'sk-SK': 'Nukeproof | Sprievodca bicyklami',
    'pl-PL': 'Nukeproof | Przewodnik rowerowy',
    'hu-HU': 'Nukeproof | Kerékpáros útmutató'
  },
  'pruvodce.button': {
    'cs-CZ': 'Zobrazit kolo',
    'sk-SK': 'Zobraziť kolo',
    'pl-PL': 'Pokaż rower',
    'hu-HU': 'Mutasd a kerékpárt'
  },

  // Table modal
  'table.close': {
    'cs-CZ': 'Zavřít',
    'sk-SK': 'Zavrieť',
    'pl-PL': 'Zamknij',
    'hu-HU': 'Bezár'
  },
  'table.loading': {
    'cs-CZ': 'Načítání tabulky...',
    'sk-SK': 'Načítava sa tabuľka...',
    'pl-PL': 'Ładowanie tabeli...',
    'hu-HU': 'Táblázat betöltése...'
  },
  'table.size': {
    'cs-CZ': 'Velikost',
    'sk-SK': 'Veľkosť',
    'pl-PL': 'Rozmiar',
    'hu-HU': 'Méret'
  },
  'table.height': {
    'cs-CZ': 'Výška postavy',
    'sk-SK': 'Výška postavy',
    'pl-PL': 'Wzrost',
    'hu-HU': 'Testmagasság'
  },
  'table.no_data': {
    'cs-CZ': 'Žádná data k dispozici',
    'sk-SK': 'Žiadne údaje k dispozícii',
    'pl-PL': 'Brak dostępnych danych',
    'hu-HU': 'Nincs elérhető adat'
  },
  'table.disclaimer': {
    'cs-CZ': '*Tabulka velikostí je orientační. Pokud si nejste jisti, jakou velikost zvolit, neváhejte nás kontaktovat.',
    'sk-SK': '*Tabuľka veľkostí je orientačná. Ak si nie ste istí, akú veľkosť zvoliť, neváhajte nás kontaktovať.',
    'pl-PL': '*Tabela rozmiarów jest orientacyjna. Jeśli nie jesteś pewien, jaki rozmiar wybrać, nie wahaj się z nami skontaktować.',
    'hu-HU': '*A mérettáblázat tájékoztató jellegű. Ha nem biztos abban, hogy melyik méretet válassza, ne habozzon kapcsolatba lépni velünk.'
  },

  // warranty
  'warranty.register': {
    'cs-CZ': 'Registrovat kolo',
    'sk-SK': 'Registrovať kolo',
    'pl-PL': 'Zarejestruj rower',
    'hu-HU': 'Kerékpár regisztráció'
  },
  'warranty.page_title': {
    'cs-CZ': 'Nukeproof | Prodloužená záruka',
    'sk-SK': 'Nukeproof | Predĺžená záruka',
    'pl-PL': 'Nukeproof | Rozszerzona gwarancja',
    'hu-HU': 'Nukeproof | Kiterjesztett garancia'
  }
};

// Country-specific map center coordinates
export const MAP_CENTERS = {
  'cs-CZ': [49.75, 15.5],    // Czech Republic center
  'sk-SK': [48.669, 19.699], // Slovakia center
  'pl-PL': [51.919, 19.145], // Poland center
  'hu-HU': [47.162, 19.503]  // Hungary center
};

// Default zoom levels per country
export const MAP_ZOOM_LEVELS = {
  'cs-CZ': 7,
  'sk-SK': 7,
  'pl-PL': 6,
  'hu-HU': 7
};

/**
 * Get map center coordinates based on current domain/language
 * @returns {Array} [latitude, longitude]
 */
export const getMapCenter = () => {
  const currentLanguage = getCurrentLanguage();
  return MAP_CENTERS[currentLanguage] || MAP_CENTERS['cs-CZ'];
};

/**
 * Get default zoom level based on current domain/language
 * @returns {number} zoom level
 */
export const getMapZoom = () => {
  const currentLanguage = getCurrentLanguage();
  return MAP_ZOOM_LEVELS[currentLanguage] || MAP_ZOOM_LEVELS['cs-CZ'];
};

/**
 * Get localized text based on current domain
 * @param {string} key - The text key to translate
 * @param {string} fallback - Fallback text if key not found
 * @returns {string} Localized text
 */
export const getLocalizedText = (key, fallback = '') => {
  const currentLanguage = getCurrentLanguage();
  if (!TEXT_DICTIONARY[key]) {
    console.warn(`Translation key "${key}" not found in TEXT_DICTIONARY`);
    return fallback || key;
  }
  const translations = TEXT_DICTIONARY[key];
  const text = translations[currentLanguage] || translations['cs-CZ'] || fallback || key;
  // Pokud je v textu &nbsp;, vrať pole React elementů
  if (typeof text === 'string' && text.includes('&nbsp;')) {
    // Rozděl text podle &nbsp; a vrať pole s React fragmenty
    return text.split('&nbsp;').map((part, i, arr) =>
      i < arr.length - 1
        ? [part, <span key={i}>&nbsp;</span>]
        : part
    ).flat();
  }
  return text;
};

/**
 * Simple function to get localized text (for use in non-React contexts)
 * @param {string} key - The text key to translate
 * @param {string} fallback - Fallback text if key not found
 * @returns {string} Localized text
 */
export const getLocalizedTextSimple = (key, fallback = '') => {
  const currentLanguage = getCurrentLanguage();
  
  if (!TEXT_DICTIONARY[key]) {
    console.warn(`Translation key "${key}" not found in TEXT_DICTIONARY`);
    return fallback || key;
  }
  
  const translations = TEXT_DICTIONARY[key];
  
  // Return translation for current language or fallback to Czech
  return translations[currentLanguage] || translations['cs-CZ'] || fallback || key;
};

/**
 * Add new translations to the dictionary at runtime
 * @param {Object} newTranslations - Object with translation keys and values
 */
export const addTranslations = (newTranslations) => {
  Object.assign(TEXT_DICTIONARY, newTranslations);
};

/**
 * Get all available languages for a specific key
 * @param {string} key - The text key
 * @returns {Object} Object with all language variants
 */
export const getAllTranslations = (key) => {
  return TEXT_DICTIONARY[key] || {};
};

const textLocalization = {
  getLocalizedText,
  getLocalizedTextSimple,
  addTranslations,
  getAllTranslations,
  TEXT_DICTIONARY
};

export default textLocalization;
